import { render, staticRenderFns } from "./PhasorTab.vue?vue&type=template&id=9af8ca54&scoped=true"
import script from "./PhasorTab.vue?vue&type=script&lang=js"
export * from "./PhasorTab.vue?vue&type=script&lang=js"
import style0 from "./PhasorTab.vue?vue&type=style&index=0&id=9af8ca54&prod&lang=scss"
import style1 from "./PhasorTab.vue?vue&type=style&index=1&id=9af8ca54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9af8ca54",
  null
  
)

export default component.exports